<template>
  <path
    d="M6 18.0002H18C18.55 18.0002 19 18.4502 19 19.0002C19 19.5502 18.55 20.0002 18 20.0002H6C5.45 20.0002 5 19.5502 5 19.0002C5 18.4502 5.45 18.0002 6 18.0002ZM11.01 13.9002C10.23 14.6702 8.97 14.6702 8.19 13.8902L6 11.7002C5.45 11.1502 5.46 10.2602 6.03 9.73019C6.57 9.21019 7.43 9.23019 7.95 9.75019L9.6 11.4002L16.03 4.97019C16.57 4.43019 17.44 4.43019 17.98 4.97019L18.02 5.01019C18.56 5.55019 18.56 6.43019 18.01 6.97019L11.01 13.9002Z"
  />
</template>
